import React, { useCallback, useMemo } from 'react'
import { useState, useEffect, useContext, useRef, useReducer } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { db, storage } from '../../config/firebase'
import Picker from "emoji-picker-react";
import addNotification from 'react-push-notification';
import { convert } from 'html-to-text'
import { v4 as uuidv4 } from 'uuid';
import ReactGA from "react-ga4";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { MdCancel } from "react-icons/md";
import { CiRead, CiUnread } from "react-icons/ci";
import {
  CiImageOn,
  CiYoutube,
  CiMusicNote1,
  CiStickyNote,
} from "react-icons/ci";
import { IoDocumentText } from "react-icons/io5";
import { LuRemoveFormatting } from "react-icons/lu";

import { BsBookmark } from "react-icons/bs";
import { BsBookmarkFill } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { BsTrash3 } from "react-icons/bs";


import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
  onSnapshot,
  startAfter
} from "firebase/firestore";
import { ClipboardItem, write } from "clipboard-polyfill"
import {
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import Spinner from '../../components/Loading/TailSpin';

import { Context } from '../../App';
import Chat from './components/Chat';
import useOutsideCloser from '../../custom hooks/clickOutsideCloser';
import MediaSelect from '../../components/Dropdown/MediaSelect';
import { TailSpin } from 'react-loader-spinner';
import ReadingModeChat from './components/readOnlyChat';
import QuillEditor from './components/Editor';
import ReadingModeChatCollapse from './components/ReadingModeChats';
import ModalAnimation from '../../components/animations/ModalAnimation';
import PopupAnimation from '../../components/animations/PopupAnimation';
import ImageModal from '../../components/media/ImageModal';

import dayjs from 'dayjs';
import ForwardPopUp from './components/ForwardPopUp';
import ChatContainer from './components/ChatContainer';
// import localizedFormat from 'dayjs/plugin/localizedFormat';
// dayjs.extend(localizedFormat);

const NUM_OF_MORE_CHATS = 6
const NUM_OF_INITIAL_CHATS = 6

function ChatSection({ groupName }) {
  const navigate = useNavigate();
  const location = useLocation();

  const uid = localStorage.getItem('uid');
  const { readingModeContext, chatsContext,
    showUsersContext,
    showMediaContext,
    groupIdContext, isGroupBookmarkedC, mediaImageListC,
    mediaDocumentListC, clickedImageC, groupsContext } = useContext(Context);
  const [showUsers, setShowUsers] = showUsersContext;
  const [showMedia, setShowMedia] = showMediaContext;
  const [groups, setGroups] = groupsContext;

  const [readingMode, setReadingMode] = readingModeContext;
  const [isGroupBookmarked, setIsGroupBookmarked] = isGroupBookmarkedC

  // const [chats, setChats] = chatsContext;
  const [chats, setChats] = useState([]);
  const [lastVisibleDoc, setLastVisibleDoc] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const chatContainerRef = useRef();



  const [mediaImageList, setMediaImageList] = mediaImageListC
  const [mediaDocumentList, setmediaDocumentList] = mediaDocumentListC
  const [clickedImg, setClickedImg] = clickedImageC

  const [collapsedchats, setCollapsedChats] = useState(chats);

  const [groupId, setGroupId] = groupIdContext;
  const [replyingToMessage, setReplyingToMessage] = useState(null);
  const [search, setSearch] = useState("");

  const [isForwardWindowOpen, setIsForwardWindowOpen] = useState(false)
  const [messageToBeForwarded, setMessageToBeForwarded] = useState(null)

  const messagesEndRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }


  // For Collaped View  -----------[ONLY IF ENABLED]
  useEffect(() => {
    if (readingMode) return;

    // scrollToBottom() //scroll to Top
    let cc = [];
    let bundle = [];
    let prevUID = chats[0]?.createdById;
    let prevDisplayName = chats[0]?.displayName;
    let prevTime = chats[0]?.createdAt;

    chats.forEach((chat) => {
      if (chat.createdById === prevUID && dayjs(chat.createdAt).diff(prevTime, 'hour') <= 3) {
        bundle.push(chat)
      } else {
        bundle.reverse()
        cc.push({
          bundle,
          himself: prevUID === uid,
          displayName: prevDisplayName,
        })
        bundle = [];
        bundle.push(chat)
        prevDisplayName = chat.displayName;
        prevUID = chat.createdById;
        prevTime = chat.createdAt;
      }

    })

    if (bundle.length) {
      bundle.reverse()
      cc.push({
        bundle,
        himself: prevUID === uid,
        displayName: prevDisplayName,
      })
    }
    setCollapsedChats(cc)
  }, [chats]);

  const [enteredMessage, setEnteredMessage] = useState("");
  const [enteredEditMessage, setEnteredEditMessage] = useState("");
  const [quillEditorEnable, setquillEditorEnable] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const onEmojiClick = (event) => {
    setEnteredMessage((prevInput) => prevInput + event.emoji);
    // setShowPicker(false);
  };
  useOutsideCloser(emojiPickerRef, setShowPicker);
  const handleKeyDown = (e) => {
    // console.log(enteredMessage.replace(/\r\n|\n|\r/g, '<br />'));
    if (e.key === 'Enter' && !e.shiftKey) {
      // console.log("SUBMIT");
      // e.preventDefault()
      handleSubmit();
    }
  }

  const [editingMessageId, setEditingMessageId] = useState(null);
  const editingMsgRef = useRef(null)
  useOutsideCloser(editingMsgRef, () => { setEditingMessageId(null) });
  useEffect(() => {
    if (editingMessageId) {
      console.log(editingMessageId);
      setEnteredEditMessage(chats?.find(item => item.id === editingMessageId)?.message || "")
    }
  }, [editingMessageId])



  useEffect(() => {
    setIsLoading(true);
    setChats([]);
    if (groupId === "") return
    let q = query(collection(db, "chats"), where("groupId", "==", groupId), orderBy("createdAt", "desc"), limit(150));

    if (isGroupBookmarked) {
      q = query(q, where("bookmarkedBy", "array-contains", uid))
    }

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const messages = [];
      const editedMessages = [];
      const editedMessagesIds = [];
      const uid = localStorage.getItem("uid");

      querySnapshot.docChanges().forEach((change) => {
        if (change.type === "added" || change.type === "removed") {

          messages.push(
            {
              ...change.doc.data(),
              id: change.doc.id,
              himself: change.doc.data().createdById === uid,
            });
        }
        else if (change.type === "modified") {
          editedMessagesIds.push(change.doc.id);
          editedMessages.push(
            {
              ...change.doc.data(),
              id: change.doc.id,
              himself: change.doc.data().createdById === uid,
            });
        }
      });

      setChats((prev) => {
        // console.log("Single Message: ", [...messages]);
        //Remove any prev Edited Message
        let unsortedList = prev.filter((item) => !editedMessagesIds.includes(item.id));

        if (messages.length === 1 && messages[0].createdById !== uid) {

          function extractContent(s) {
            var span = document.createElement('span');
            span.innerHTML = s;
            return span.textContent || span.innerText;
          };

          addNotification({
            title: 'New Message',
            subtitle: messages[0].displayName,
            message: extractContent(messages[0].message),
            theme: 'darkblue',
            native: true // when using native, your OS will handle theming.
          })
        }

        unsortedList = [...unsortedList, ...messages, ...editedMessages];

        return (unsortedList.sort(function (a, b) {
          if (a.createdAt <= b.createdAt) { return 1; }
          if (a.createdAt > b.createdAt) { return -1; }
        }));
      });

      ReactGA.event({
        category: "Message",
        action: "Initially Loaded Message",
        label: localStorage.getItem("displayName"),
      });

    });
    setIsLoading(false)
    // Clean up the listener when the component unmounts
    return () => unsubscribe();
  }, [isGroupBookmarked]);




  // -------------------- Initial one-time fetch (descending order) --------------------
  useEffect(() => {
    setChats([]);
    setLastVisibleDoc(null);
    setHasMore(true);

    if (!groupId) return;

    const fetchInitialMessages = async () => {
      let q = query(
        collection(db, "chats"),
        where("groupId", "==", groupId),
        orderBy("createdAt", "desc"),
        limit(NUM_OF_INITIAL_CHATS)
      );

      if (isGroupBookmarked) {
        q = query(q, where("bookmarkedBy", "array-contains", uid));
      }

      const snapshot = await getDocs(q);

      const messages = snapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          ...data,
          id: doc.id,
          himself: data.createdById === uid,
        };
      });

      if (snapshot.docs.length > 0) {
        setLastVisibleDoc(snapshot.docs[snapshot.docs.length - 1]);
      }

      setChats(messages);
      setHasMore(snapshot.docs.length === NUM_OF_INITIAL_CHATS);
    };

    fetchInitialMessages();
  }, [groupId, isGroupBookmarked]);

  // -------------------- Real-time listener for new messages --------------------
  useEffect(() => {
    if (!groupId) return;

    const q = query(
      collection(db, "chats"),
      where("groupId", "==", groupId),
      orderBy("createdAt", "desc"),
      limit(1)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          const data = change.doc.data();

          setChats((prev) => {
            if (prev.some((msg) => msg.id === change.doc.id)) return prev;

            return [
              {
                ...data,
                id: change.doc.id,
                himself: data.createdById === uid,
              },
              ...prev,
            ];
          });

          scrollToBottom()
        }
      });
    });

    return () => unsubscribe();
  }, [groupId]);

  // -------------------- Load older messages on scroll (pagination) --------------------
  const loadMoreMessages = async () => {
    if (isLoadingMore || !lastVisibleDoc || !hasMore) return;

    setIsLoadingMore(true);

    let q = query(
      collection(db, "chats"),
      where("groupId", "==", groupId),
      orderBy("createdAt", "desc"),
      startAfter(lastVisibleDoc),
      limit(NUM_OF_INITIAL_CHATS)
    );

    if (isGroupBookmarked) {
      q = query(q, where("bookmarkedBy", "array-contains", uid));
    }

    const snapshot = await getDocs(q);
    const newMessages = [];

    snapshot.forEach((doc) => {
      const data = doc.data();
      newMessages.push({
        ...data,
        id: doc.id,
        himself: data.createdById === uid,
      });
    });

    // 🚨 Update this BEFORE setChats to prevent race conditions
    if (snapshot.docs.length > 0) {
      setLastVisibleDoc(snapshot.docs[snapshot.docs.length - 1]);
    }

    // ✅ Merge without duplicates
    setChats((prev) => {
      const map = new Map(prev.map((m) => [m.id, m]));
      newMessages.forEach((m) => map.set(m.id, m));
      return Array.from(map.values()).sort((a, b) => b.createdAt - a.createdAt);
    });

    setHasMore(snapshot.docs.length === NUM_OF_INITIAL_CHATS);
    setIsLoadingMore(false);
  };


  useEffect(() => {
    const el = chatContainerRef.current;
    if (!el) return;

    const onScroll = () => {
      const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 300;
      if (nearBottom) {
        loadMoreMessages();
      }
    };

    el.addEventListener('scroll', onScroll);
    return () => el.removeEventListener('scroll', onScroll);
  }, [loadMoreMessages]);




  const [mediaUploadLoading, setMediaUploadLoading] = useState(false);
  const [showImagePopup, setShowImagePopup] = useState(false);
  const imagePopupRef = useRef(null);
  useOutsideCloser(imagePopupRef, setShowImagePopup)

  const [messageToBeDeletedId, setMessageToBeDeletedId] = useState(null)
  const deleteMessageConfRef = useRef(null);
  useOutsideCloser(deleteMessageConfRef, setMessageToBeDeletedId)


  const handleDeleteMessage = async () => {

    const docRef = doc(db, 'chats', messageToBeDeletedId);

    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, {
          deleted: true,
        });
        setMessageToBeDeletedId(false)
        // console.log("Document successfully Deleted: ",);
      } else {
        // console.log("DNE: ",);
      }

    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  };


  const sendChatToFireStore = async (dataFromRtdb, id) => {

    try {
      const docRef = doc(db, 'chats', id);
      await setDoc(docRef, { ...dataFromRtdb, quillEditorEnable });
      // console.log("Document Uploaded", dataFromRtdb);
      ReactGA.event({
        category: "Message",
        action: "Sent Message",
        label: localStorage.getItem("displayName"),
      });
    } catch (error) {
      console.log(error);
    }
    setMediaUploadLoading(false);
  }

  // ===================| MAIN PUSH |=================================================
  const handleAddMessage = async () => {
    const enteredData = {
      createdAt: dayjs().format(),
      message: enteredMessage,
      groupId,
      createdById: localStorage.getItem("uid"),
      displayName: localStorage.getItem("displayName"),
    }

    if (enteredMessage !== "")
      sendChatToFireStore(enteredData, uuidv4())
    setEnteredMessage("");
  };


  const [imageUpload, setImageUpload] = useState(null);
  const [docUpload, setDocUpload] = useState(null);
  const [docUploadName, setDocUploadName] = useState(null);
  const [videoUpload, setVideoUpload] = useState(null);
  const [audioUpload, setAudioUpload] = useState(null);

  const [imagePreview, setImagePreview] = useState(null)

  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!imageUpload) {
      return
    }

    const objectUrl = URL.createObjectURL(imageUpload)
    setImagePreview(objectUrl)

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl)
  }, [imageUpload])


  const [openWrapperMedia, setOpenWrapperMedia] = useState(false);
  const [mediaDropdown, setMediaDropdown] = useState([
    {
      name: "Image",
      icon: <CiImageOn className='w-4 h-4' />,
      allowed: "image/*",
      onClick: (e) => { setImageUpload(e.target.files[0]) },
    },
    {
      name: "Video",
      icon: <CiYoutube className='w-4 h-4' />,
      allowed: "video/*",
      onClick: () => { },
    },
    {
      name: "Audio",
      icon: <CiMusicNote1 className='w-4 h-4' />,
      allowed: "audio/*",
      onClick: () => { },
    },
    {
      name: "Document",
      icon: <CiStickyNote className='w-4 h-4' />,
      allowed: "*",
      onClick: (e) => { setDocUpload(e.target.files[0]) },
    },
    ,]
  )

  function addTimestampBeforeExtension(rawFilename) {
    const datetime = dayjs().format("YYYYMMDD_HHmmssSSS"); // no timezone
    const filename = rawFilename.replace(/\s+/g, "_"); // replace spaces
    const lastDot = filename.lastIndexOf(".");

    if (lastDot === -1) {
      // No extension found
      return `${filename}_${datetime}`;
    }

    const name = filename.substring(0, lastDot);
    const extension = filename.substring(lastDot); // includes '.'

    return `${name}_${datetime}${extension}`;
  }

  const uploadGlobalFile = (folder, field, file) => {
    setMediaUploadLoading(true);
    const randomId = uuidv4();
    const imageRef = ref(storage, `${folder}/${groupName}/${addTimestampBeforeExtension(file.name)}`);


    uploadBytes(imageRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {

        const enteredData = {
          createdAt: dayjs().format(),
          message: enteredMessage,
          groupId,
          createdById: localStorage.getItem("uid"),
          displayName: localStorage.getItem("displayName"),
          url,
          documentName: file.name,
          mediaType: field
        }

        sendChatToFireStore(enteredData, randomId);
        setImagePreview(null);
        setDocUpload(null);
        setEnteredMessage("");
      });
    }, (reason) => console.log(reason));
  };

  const replyToMessage = async () => {
    const enteredData = {
      createdAt: dayjs().format(),
      message: enteredMessage,
      groupId,
      createdById: localStorage.getItem("uid"),
      displayName: localStorage.getItem("displayName"),
      replyingToId: replyingToMessage.id,
      replyingToDisplayName: replyingToMessage.displayName,
      replyToMessage: replyingToMessage.messageToDisplay,
    }

    if (enteredMessage !== "")
      // console.log(enteredData);
      sendChatToFireStore(enteredData, uuidv4())
    setEnteredMessage("");
    setReplyingToMessage(null);
  }

  const handleSubmit = () => {
    if (imagePreview) {
      // const isImage = true;
      uploadGlobalFile("images", "img", imageUpload);
    } else if (docUpload) {
      // console.log("DOCS");
      uploadGlobalFile("documents", "doc", docUpload);

    } else if (replyingToMessage) {
      console.log("REPLY");
      replyToMessage();

    } else {
      handleAddMessage();
    }
  }


  const handleForwardMessage = useCallback((message) => {
    setIsForwardWindowOpen(true);
    setMessageToBeForwarded(message);
  }, [setIsForwardWindowOpen, setMessageToBeForwarded]);


  const handleEditMessage = async () => {

    const docRef = doc(db, 'chats', editingMessageId);

    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, {
          edited: true,
          message: enteredEditMessage,
        });
        setEditingMessageId(null)
      } else {
        // console.log("DNE: ",);
      }

    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  };

  const handleEditKeyDown = (e) => {
    // if (e.key === 'Enter' && !e.shiftKey) {
    //   // console.log("SUBMIT");
    //   handleEditMessage();
    // }
    if (e.key === 'Escape') {
      // console.log("SUBMIT");
      setEditingMessageId(null);
    }
  }


  const handleMessageCopy = async (html) => {
    console.log("copied");

    const item = new ClipboardItem({
      "text/html": new Blob([html], { type: "text/html" }),
      "text/plain": new Blob([stripHtmlTags(html)], { type: "text/plain" }),
    });

    await write([item]);
  };

  // Utility function to strip HTML tags for plain text fallback
  function stripHtmlTags(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  if (groupId !== "")
    return (
      <div className="relative w-full flex flex-col h-full">

        {/* Bookmark & Reading Mode (EYES) */}
        <div className=" w-full h-fit min-h-[35px] md:min-h-[50px] flex items-center justify-center  bg-lightPrimary pb-1">
          <div onClick={() => { setIsGroupBookmarked((prev) => (!prev)) }}
            className="absolute top-2.5 left-3 cursor-pointer ">
            {isGroupBookmarked ?
              <BsBookmarkFill className='w-4 h-4 md:w-5 md:h-5  text-headPrimary  hover:text-our-600' />
              :
              <BsBookmark className='w-4 h-4 md:w-5 md:h-5 text-gray-500 hover:text-headPrimary ' />
            }
          </div>

          <div className="absolute left-10 md:left-12 top-2 h-fit w-[73px] md:w-[120px] ">
            <div className="border border-gray-300 bg-white text-gray-700 z-1 flex h-[20px] md:h-[24px] w-full flex-grow items-left justify-start gap-2 rounded-md px-1 py-px">
              <div className="flex h-full w-full items-center font-normal ">
                <FiSearch
                  className="h-3 w-3 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                <input
                  onChange={(e) => {
                    setSearch((e.target.value))
                  }}
                  value={search}
                  type="text"
                  placeholder="Search"
                  className="block ml-0 px-1 h-auto w-full bg-white text-xs text-gray-700 outline-none placeholder:!text-gray-300"
                />
              </div>

            </div>
          </div>

          <div onClick={() => { setReadingMode((prev) => (!prev)) }}
            className="absolute top-2.5 right-3 text-gray-500 hover:text-headPrimary cursor-pointer ">
            {readingMode ?
              <CiRead className='w-5 h-5 md:w-6 md:h-6 ' />
              :
              <CiUnread className='w-5 h-5 md:w-6 md:h-6 ' />
            }
          </div>
        </div>

        {/* ---------------| Reply Preview |--------------------- */}
        {replyingToMessage &&
          <div className="w-full bg-lightPrimary flex pl-[100px] md:pl-[121px] pt-1 pr-[59px] md:pr-[82px] flex items-center">
            <div className={`relative max-w-full rounded-lg ${replyingToMessage.himself ? "bg-lightSecondary" : "bg-lightPrimary"} border border-gray-300 flex items-center p-0.5 px-2 pr-5 truncate`}>

              <RxCross2 onClick={() => { setReplyingToMessage(null) }}
                className='absolute top-0.5 right-0.5 h-3 w-3 text-gray-600 hover:text-headPrimary cursor-pointer' />

              <div className="text-2xs text-gray-600 mr-2">Replying to <span className="font-bold">{replyingToMessage.displayName} :</span> </div>

              <div className="text-sm truncate">{replyingToMessage.messageToDisplay} </div>
            </div>
          </div>
        }

        {/* ---------------| TEXT AREA |--------------------- */}
        <div className="flex items-center px-2 md:px-3 py-2 md:py-3 md:pt-2 bg-lightPrimary dark:bg-gray-700">
          <div className="flex items-center">
            <MediaSelect mediaData={[mediaDropdown, setMediaDropdown]} wrapperData={[openWrapperMedia, setOpenWrapperMedia]} />
          </div>

          <div className="flex items-center">
            <button onClick={() => { setShowPicker((prev) => !prev) }} type="button"
              className="ml-1 p-1 text-gray-500 rounded-lg cursor-pointer hover:text-headPrimary hover:bg-our-200 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
              <svg className="w-4 h-4 md:w-5 md:h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.408 7.5h.01m-6.876 0h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM4.6 11a5.5 5.5 0 0 0 10.81 0H4.6Z" />
              </svg>
            </button>
          </div>

          <div className="flex items-center">
            <button onClick={() => { setquillEditorEnable((prev) => !prev) }} type="button"
              className={`ml-1 p-1 ${quillEditorEnable ? "text-white bg-headPrimary hover:text-gray-200" : "hover:bg-our-200 hover:text-headPrimary text-gray-500"} rounded-lg cursor-pointer  `}>
              <LuRemoveFormatting className="w-4 h-4 md:w-5 md:h-5" />
            </button>
          </div>

          {/* <textarea id="chat" rows="2"
            value={enteredMessage}
            onKeyDown={handleKeyDown}
            onChange={(e) => { setEnteredMessage(e.target.value) }}
            className="block mx-4 py-1.5 px-2.5 w-full text-base text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-headPrimary focus:border-headPrimary dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-headPrimary dark:focus:border-headPrimary" placeholder="Your Message..."></textarea> */}
          <QuillEditor handleKeyDown={handleKeyDown} EnteredMessageData={[enteredMessage, setEnteredMessage]} />

          {imagePreview &&
            <div
              onClick={() => {
                setImageUpload(null)
                setImagePreview(null)
              }} className={`cursor-pointer min-w-[50px] w-[50px] h-[50px] bg-white relative border border-gray-400 rounded-md mr-1 group p-1`}>

              <img className="h-full w-full object-cover group-hover:opacity-50"
                src={imagePreview} alt="" />

              <div className="hidden group-hover:flex absolute top-0 bottom-0 left-0 right-0 m-auto items-center justify-center ">
                <MdCancel className='w-6 h-6 text-gray-800 bg-white rounded-full' />
              </div>

              {(mediaUploadLoading) &&
                <div className="w-full h-full p-px rounded-md /bg-[#ffffff4f] absolute top-0 bottom-0 left-0 right-0 m-auto ">< Spinner size={"30"} /></div>
              }
            </div>
          }

          {docUpload &&
            <div
              onClick={() => {
                setDocUpload(null)
              }} className={`cursor-pointer min-w-[50px] w-[50px] h-[50px] bg-white relative border border-gray-400 rounded-md mr-1 group p-1`}>

              <IoDocumentText className='h-full w-full group-hover:opacity-50' />

              <div className="hidden group-hover:flex absolute top-0 bottom-0 left-0 right-0 m-auto items-center justify-center ">
                <MdCancel className='w-6 h-6 text-gray-800 bg-white rounded-full' />
              </div>

              {(mediaUploadLoading) &&
                <div className="w-full h-full p-px rounded-md /bg-[#ffffff4f] absolute top-0 bottom-0 left-0 right-0 m-auto ">< Spinner size={"30"} /></div>
              }
            </div>
          }


          <button
            onClick={handleSubmit}
            type="submit" className="inline-flex justify-center p-1 md:p-2 text-headPrimary rounded-full cursor-pointer hover:bg-our-200 dark:text-headPrimary dark:hover:bg-gray-600">
            <svg className="w-7 h-7 md:w-9 md:h-9 rotate-90 rtl:-rotate-90" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
              <path d="m17.914 18.594-8-18a1 1 0 0 0-1.828 0l-8 18a1 1 0 0 0 1.157 1.376L8 18.281V9a1 1 0 0 1 2 0v9.281l6.758 1.689a1 1 0 0 0 1.156-1.376Z" />
            </svg>
            <span className="sr-only">Send Message</span>
          </button>
        </div>

        {/* --------------------------------------------| Chat List Area |---------------------- */}
        <ChatContainer
          ref={chatContainerRef}
          replyingToMessage={replyingToMessage}
          messagesEndRef={messagesEndRef}
          readingMode={readingMode}
          chats={chats}
          search={search}
          collapsedchats={collapsedchats}
          setClickedImg={setClickedImg}
          setShowImagePopup={setShowImagePopup}
          setReplyingToMessage={setReplyingToMessage}
          setMessageToBeDeletedId={setMessageToBeDeletedId}
          setChats={setChats}
          uid={uid}
          handleForwardMessage={handleForwardMessage}
          handleMessageCopy={handleMessageCopy}
          setEditingMessageId={setEditingMessageId}
          isLoading={isLoading || isLoadingMore}
        />

        {/* {imagePreview && (
          <span className='absolute top-[7.5rem] left-0 p-2 bg-lightPrimary rounded-b-lg border-l border-r border-b ' >
            <img className='bg-white' src={imagePreview} alt="" width={300} />
          </span>
        )} */}


        <span ref={emojiPickerRef}
          className={`absolute top-[6.5rem] left-0  origin-[56px_-10px] transition-all duration-[300ms] ease-in-out ${showPicker ? "scale-100" : "scale-0"}`} ><Picker pickerStyle={{ width: "fit-content" }} onEmojiClick={onEmojiClick} /></span>

        <ImageModal clickedImg={clickedImg} imagePopupRef={imagePopupRef}
          onClose={() => {
            setClickedImg(null)
          }}
          uid={uid}
          setClickedImg={setClickedImg}
          mediaImageList={mediaImageList}
        />

        <ForwardPopUp isForwardWindowOpenData={[isForwardWindowOpen, setIsForwardWindowOpen]}
          groups={groups}
          message={messageToBeForwarded}
        />

        <ModalAnimation showDiv={messageToBeDeletedId}>
          <div ref={deleteMessageConfRef} className="relative flex w-[290px] h-fit flex-col items-center p-5 tracking-wide rounded-xl bg-white outline-none dark:bg-navy-800 focus:outline-none">

            <div className="rounded-full bg-red-600 w-12 h-12 p-2.5">
              <BsTrash3 className='h-full w-full text-white' />
            </div>

            <div className="text-xl font-bold text-center mt-4">
              Delete Confirmation
            </div>

            <div className="text-base text-center text-gray-700 mt-1">
              Are you sure you want to Permanently Delete Message ?
            </div>

            <button
              onClick={() => { handleDeleteMessage() }}
              className="text-base font-bold bg-lightPrimary hover:text-white hover:bg-headPrimary px-5 py-2 rounded-md cursor-pointer mt-6">
              DELETE
            </button>
          </div>
        </ModalAnimation>


        <PopupAnimation showDiv={editingMessageId} >
          <div ref={imagePopupRef} className="relative flex w-[95vw] h-[90vh] md:w-[80vw] md:h-[80vh]  p-4 pt-4 md:p-5 flex-col justify-start rounded-xl bg-lightPrimary shadow-lg outline-none dark:bg-navy-800 focus:outline-none">

            <button
              onClick={() => {
                setEditingMessageId(null)
              }}
              type="button"
              className="bg-transparent absolute absolute top-0 right-0 h-fit w-fit p-2 items-center justify-center rounded-xl text-sm text-gray-400 ms-auto hover:bg-gray-200 hover:text-neuGray dark:hover:bg-gray-600 dark:hover:text-white"
              data-modal-hide="static-modal"
            >
              <svg
                className="h-3 w-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>

            <div className="text-2xl font-semibold text-center text-headPrimary shrink-0"> EDIT MESSAGE </div>
            <div className='w-full grow min-h-0 p-2 mt-3 flex flex-col bg-lightPrimary rounded-lg' >

              <QuillEditor className='rounded-lg w-full h-full bg-white border border-gray-300'
                handleKeyDown={handleEditKeyDown}
                EnteredMessageData={[enteredEditMessage, setEnteredEditMessage]}
                allowEnter={true} />
            </div>

            <div className="w-full flex items-center justify-center shrink-0">

              <button
                onClick={() => { handleEditMessage() }}
                className=" mt-5 flex items-center justify-center py-2 w-[200px] bg-white rounded-md border text-2xl text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold">
                SAVE
              </button>

            </div>
          </div>
        </PopupAnimation>

      </div >

    )
  else
    return (
      <div className="w-full h-full flex items-center justify-center">
        <div
          onClick={() => { setShowUsers(true) }}
          className="text-lg font-normal text-[#91edb8] md:hover:text-headPrimary cursor-pointer select-none">Click here to Select a Group</div>
      </div>
    )
}

export default ChatSection